import * as React from 'react';
import FavouriteViewModel from '../Utilities/ViewModels/FavouriteViewModel';
import { ResponseType, TokenRefreshContext } from './TokenRefreshContext';
import authService from '../api-authorization/AuthorizeService';

type ContextType = {
    favourites: FavouriteViewModel[];
    getFavourites: () => void;
    toggleClient: (client: number, onSuccess?: () => void) => void;
    togglePlant: (plant: number, onSuccess?: () => void) => void;
};

type FavouritesProviderProps = { children: React.ReactNode };

export const FavouritesContext = React.createContext<ContextType>({
    favourites: [],
    getFavourites: () => {
        throw Error('Cannot use a context without a provider');
    },
    toggleClient: () => {
        throw Error('Cannot use a context without a provider');
    },
    togglePlant: () => {
        throw Error('Cannot use a context without a provider');
    }
});

export default function FavouritesProvider({ children }: FavouritesProviderProps) {
    const { crabFetch } = React.useContext(TokenRefreshContext);
    const [favourites, setFavourites] = React.useState<FavouriteViewModel[]>([]);
    const authSubscription = authService.subscribe(() => getFavourites());

    React.useEffect(() => {
        return () => {
            authService.unsubscribe(authSubscription);
        }
    }, []);

    const toggleClient = async (clientId: number, onSuccess?: () => void) => {
        const token = await authService.getAccessToken();

        let url = `Menu/UpdateMenuFavourite`;
        const fave = new FavouriteViewModel();
        fave.clientId = clientId;

        crabFetch(url, {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json; charset=utf-8' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(fave)
        }, ResponseType.Text,
            (data: any) => {
                getFavourites();

                if (onSuccess) {
                    onSuccess();
                }
            },
            (error: any) => {
            }
        );
    }

    const togglePlant = async (plantId: number, onSuccess?: () => void) => {
        const token = await authService.getAccessToken();

        let url = `Menu/UpdateMenuFavourite`;
        const fave = new FavouriteViewModel();
        fave.plantId = plantId;

        crabFetch(url, {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json; charset=utf-8' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(fave)
        }, ResponseType.Text,
            (data: any) => {
                getFavourites();

                if (onSuccess) {
                    onSuccess();
                }
            },
            (error: any) => {
            }
        );
    }

    const getFavourites = async () => {
        const token = await authService.getAccessToken();

        crabFetch(`Menu/GetMenuFavourites`, {
            headers: !token ? { 'Content-Type': 'application/json; charset=utf-8' } : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json; charset=utf-8' },
        }, ResponseType.JSON,
            (data) => {
                setFavourites(data);
            },
            () => {
            }
        );
    }

    return (
        <FavouritesContext.Provider value={{ favourites, toggleClient, togglePlant, getFavourites }}>
            {children}
        </FavouritesContext.Provider>
    );
}